/*====== import  ======*/
/*------ React ------*/
import React, { useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import { useMsal,AuthenticatedTemplate,UnauthenticatedTemplate } from "@azure/msal-react"
/*------ CSS ------*/
// import styled from 'styled-components';
/*------ Component Js/Jsx ------*/
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
/*====== Styles  ======*/
/*------ Styled Components ------*/

/*====== global variables ======*/

/*====== global functions ======*/
const signInClickHandler = async(instance) => {
	// await instance.loginPopup()  // iframe logoutRedirect
    await instance.loginRedirect()
    .then((res)=>{
        // console.log(res);
    })
    .catch((e)=>{
        // console.log(e);
    });
};
const SignIn = () =>{
	// useMsal hook will return the PublicClientApplication instance you provided to MsalProvider
	const { instance } = useMsal();
	useEffect(()=>{
        // if(accounts.length){

		// window.top.location ='https://raveng.sharepoint.com/sites/test';
        // }
		signInClickHandler(instance);
        // eslint-disable-next-line react-hooks/exhaustive-deps
	},[]);
};

const WelcomeUser = () => {
    const navigate = useNavigate();//画面遷移用
	useEffect(()=>{
	console.log('GetAuth01')
		navigate('/authca');
         // eslint-disable-next-line react-hooks/exhaustive-deps
	},[]);
  }

/* --------------------------- */
/* ---------- main ---------- */
/* --------------------------- */
export const GetAuth01 = () =>{ //認証・認可(自動ログイン)
    /* --------------------------- */
    /* -------- instance  -------- */
    /* --------------------------- */

    /* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */

    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */

    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    
    /* --------------------------- */
    /* ---------- data ----------- */
    /* --------------------------- */

    return(
        <>
            <AuthenticatedTemplate>
                <WelcomeUser />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <LoadingProgressBar open={true}/>
                <SignIn />
            </UnauthenticatedTemplate>
        </>
    );
}